module.exports = __webpack_public_path__ + "static/media/8.314d5729.png";